<div class="interface-control__custom-pair-field__container">
  <bfx-autoComplete
    #inputField
    [(ngModel)]="data.item"
    [label]="label | capitalize:true"
    [suggestions]="data.filteredItems"
    (completeMethod)="search($event)"
    [disabled]="data.disabled || locked"
    (onFocus)="onFocus($event)"
    (onBlur)="onBlur($event)"
    (onSelect)="onSelect($event)"
    nativeDesktopDropdown="ccyPairString"
    target="ccyPairString"
    autoHighlight="true"
    delay="4"
    [skipSorting]="true"
    [skipBlur]="false"
    [state]="data.state"
    [dropdown]="true"
    [size]="'sm'"
    [minLength]="1"
    [maxlength]="6"
    [appendTo]="'body'"
    [fieldSuffix]="data.inverted ? '<sup>1</sup>/<sub>n</sub>' : ''"
  >
  </bfx-autoComplete>
</div>
<div class="interface-control__custom-pair-field__rate">
  <div class="bfx-input-label bfx-input-label-sm-bold bfx-input-label-read-only">Market Spot</div>
  <div
    [ngClass]="{'interface-control__custom-pair-field__rate__value': true, 
    'interface-control__custom-pair-field__rate__value-base': true,
    'interface-control__custom-pair-field__rate__value-base--locked': locked,
    'interface-control__custom-pair-field__rate__value-base--invalid': data.state === 1,
    'interface-control__custom-pair-field__rate__value-base--active': data.state === 2,
    'interface-control__custom-pair-field__rate__value-base--inactive': data.state === 3,
    'interface-control__custom-pair-field__rate__value-base--strikethrough': marketRate.invalid && !locked,
    'interface-control__custom-pair-field__rate__value-base--strikethrough-locked': marketRate.invalid && locked
  }"
  >
    {{marketRate.bidStr}}&nbsp;{{(marketRate.bidStr != '' && marketRate.bidStr
    !='')?marketRate.divider:''}}&nbsp;{{marketRate.offerStr}}
  </div>
</div>
